import {
  Directive, HostListener, ElementRef, AfterViewInit, Renderer2, Input,
  OnChanges, SimpleChanges, Optional, Self
} from '@angular/core';
import { NgStyle } from '@angular/common';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input[type=floatNumber]',
    standalone: false
})
export class FloatNumberDirective implements AfterViewInit, OnChanges {
  // tslint:disable-next-line:no-input-rename
  @Input('style') styles;

  constructor(private elementRef: ElementRef, private renderer: Renderer2,
    @Optional() @Self() private ngStyle: NgStyle) { }
  ngAfterViewInit() {

    if (this.styles) {
      if (this.styles.search('padding-left:') !== -1 || this.styles.search('padding-right:') !== -1) {
        this.styles.split(';').forEach(element => {
          const style = element.split(':');
          if (style[0].includes('padding-left')) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', style[1].trim());

          } else if (element.split(':')[0].includes('padding-right')) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'padding-right', style[1].trim());
          }
        });
      } else {
        this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', '4px');
        this.renderer.setStyle(this.elementRef.nativeElement, 'padding-right', '4px');
      }
    } else {
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', '4px');
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-right', '4px');
    }

  }
  @HostListener('input', ['$event'])
  oninput(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

  }
  ngOnChanges(changes: SimpleChanges): void { }
  @HostListener('keypress', ['$event'])
  keyPress(event: KeyboardEvent) {
    const value: string = this.elementRef.nativeElement.value;
    if ((event.which !== 46 || value.indexOf('.') !== -1) && (event.which < 48 || event.which > 57) && event.which !== 8) {
      event.preventDefault();
    }
  }
}

